// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3DZXa","buttons":"Footer_buttons__1AJ6O"};